import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="business-hours"
export default class extends Controller {
  static targets = ["row", "opensAt", "closesAt"];

  toggleOpen(event) {
    const row = event.target.closest('[data-business-hours-target="row"]');
    const opensAt = row.querySelector('[data-business-hours-target="opensAt"]');
    const closesAt = row.querySelector('[data-business-hours-target="closesAt"]');
    const checked = event.target.checked;
    opensAt.disabled = !checked;
    closesAt.disabled = !checked;
    // if (!checked) {
    //   opensAt.value = "";
    //   closesAt.value = "";
    // }
  }
}
